import { Box } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { API_POST, DBRequest, useConfig } from '../../../api/api';
import ExoStepper, { FinalPage } from '../ExoStepper';
import SelectPositions from '../../select/SelectPositions';
import StepOrder from '../../steps/StepOrder';
import StepInvoice from '../../steps/StepInvoice';

export const ServiceSelector = ({
  project,
  onClose,
  reloadApiData,
  type = 'order',
  onSubmit,
}) => {
  const { t } = useTranslation();
  const config = useConfig();

  const orderSteps = [
    {
      label: t('Order'),
      valid: false,
      content: ({
        updateDataCollection,
        activeStep,
        setActiveStep,
        step,
        dataCollection,
        updateValidation,
      }) => (
        <StepOrder
          totalAmount
          apiUrl={`projects/${project.id}/orders`}
          onClose={onClose}
          dataCollection={dataCollection}
          updateDataCollection={updateDataCollection}
          activeStep={activeStep}
          setActiveStep={setActiveStep}
          step={step}
          updateValidation={updateValidation}
        />
      ),
    },
    {
      label: t('Positions'),
      content: ({ dataCollection, updateValidation, updateDataCollection }) => (
        <StepPositions
          allowAll
          updateDataCollection={updateDataCollection}
          dataCollection={dataCollection}
          updateValidation={updateValidation}
          type={type}
        />
      ),
    },
  ];

  const invoiceSteps = [
    {
      label: t('Invoice'),
      valid: false,
      content: ({
        updateDataCollection,
        activeStep,
        setActiveStep,
        step,
        dataCollection,
        updateValidation,
      }) => (
        <StepInvoice
          apiUrl={'invoices/has-no-project-in-position'}
          onClose={onClose}
          dataCollection={dataCollection}
          updateDataCollection={updateDataCollection}
          activeStep={activeStep}
          setActiveStep={setActiveStep}
          step={step}
          updateValidation={updateValidation}
        />
      ),
    },
    {
      label: t('Positions'),
      content: ({ dataCollection, updateValidation, updateDataCollection }) => (
        <StepPositions
          updateDataCollection={updateDataCollection}
          dataCollection={dataCollection}
          updateValidation={updateValidation}
          type={type}
        />
      ),
    },
  ];

  const typeMap = {
    order: {
      relationType: 'orderPositions',
      steps: orderSteps,
      label: t('Create Service from Order'),
    },
    invoice: {
      relationType: 'invoicePositions',
      steps: invoiceSteps,
      label: t('Link Invoice to Project'),
    },
  };

  const finalStep = {
    operation: ({
      dataCollection,
      handleResponse,
      setIsLoading,
      handleError,
    }) => {
      setIsLoading(false);
      onSubmit(dataCollection.positions);
      onClose();
    }, // your operation with the data
    content: (response) => <FinalPage response={response} />, // component with final operations and the feedback
  };

  return (
    <ExoStepper
      onClose={onClose}
      data={typeMap[type].steps}
      finalStep={finalStep}
      label={typeMap[type].label}
    />
  );
};

const StepPositions = ({
  dataCollection,
  updateValidation,
  updateDataCollection,
  type,
  allowAll,
}) => {
  const { t } = useTranslation();

  const newPos = (
    dataCollection[type] ? dataCollection[type].positions : []
  ).map((pos) => {
    return { ...pos, status: null };
  });

  //load positions
  function handleSelectedPositions(positions) {
    updateDataCollection({ positions: positions });
    updateValidation(true);
  }
  return (
    <SelectPositions
      allowAll={allowAll}
      positions={newPos}
      isLoading={!Boolean(dataCollection[type])}
      onSelect={handleSelectedPositions}
    />
  );
};
